import { rest } from 'msw';
import { getConfig } from 'shared/config';
import {
  additionalUsage,
  fixedNetMenuItem,
  fixednetSubscription,
  getAddonProductsLandlineMock,
  landlineSettingsMock,
  voiceMailInformation,
} from '.';

export const handlers = [
  rest.get(
    `${getConfig().odin?.host}/yousee/selfcare/products/MOCK_FIXEDNET/menu-details`,
    (req, res, ctx) => res(ctx.json(fixedNetMenuItem)),
  ),
  rest.get(
    `${getConfig().odin?.host}/yousee/selfcare/subscriptions/MOCK_FIXEDNET`,
    (req, res, ctx) => res(ctx.json(fixednetSubscription)),
  ),
  rest.get(
    `${getConfig().odin?.host}/yousee/selfcare/subscriptions/MOCK_FIXEDNET/addonproducts`,
    (req, res, ctx) => res(ctx.json(getAddonProductsLandlineMock)),
  ),
  rest.get(
    `${getConfig().odin?.host}/yousee/selfcare/subscriptions/MOCK_FIXEDNET/settings`,
    (req, res, ctx) => res(ctx.json(landlineSettingsMock)),
  ),
  rest.get(
    `${getConfig().odin?.host}/yousee/selfcare/subscriptions/:subscriptionId/usage/additional`,
    (req, res, ctx) => {
      return res(ctx.json(additionalUsage));
    },
  ),
  rest.get(
    `${getConfig().odin
      ?.host}/yousee/selfcare/subscriptions/:subscriptionId/mavenirvoicemailinformation`,
    (req, res, ctx) => res(ctx.json(voiceMailInformation)),
  ),
  rest.put(
    `${getConfig().odin
      ?.host}/yousee/selfcare/subscriptions/:subscriptionId/mavenirvoicemailinformation`,
    (req, res, ctx) => res(ctx.json({})),
  ),
];
